
function loadPosts(setPosts, pageNo) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + "/wp-json/wp/v2/posts?per_page=5&page=" + (pageNo || 1),
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        setPosts(data)
    })
}

function loadAlerts(setAlerts) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + "/wp-json/wp/v2/surgosuzenetek?_embed",
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        setAlerts(data)
    })
}


function checkIfPageExists(setIfPageExists, pageNo) {
    if (pageNo === 1) {
        setIfPageExists(true)
        return
    }
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + "/wp-json/wp/v2/posts?per_page=5&page=" + (pageNo || 1),
        {
            method: "GET"
        }
    ).then((data) => {
        if (data.status === 200) {
            setIfPageExists(true)
        } else {
            setIfPageExists(false)
        }
    })
}

function loadSponsors(setSponsors) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + "/wp-json/wp/v2/sponsor?_embed&orderby=date&order=asc&per_page=100",
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        if (data.toString() === '[]') {
            setSponsors(null)
            return
        }
        setSponsors(data)
    })
}

function loadProjects(setProjects) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + "/wp-json/wp/v2/project?_embed&orderby=date&order=asc&per_page=100",
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        if (data.toString() === '[]') {
            setProjects(null)
            return
        }
        setProjects(data)
    })
}

function loadPost(id, setPost) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + `/wp-json/wp/v2/posts/${id}`,
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        setPost(data)
    })
}

function loadMedia(id, setMedia) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + `/wp-json/wp/v2/media/${id}`,
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        setMedia(data.source_url)
    })
}

function loadPage(slug, setPage) {
    fetch(process.env.REACT_APP_HEADLESS_WP_URL + `/wp-json/wp/v2/pages?slug=${slug}&_embed`,
        {
            method: "GET"
        }
    ).then((data) => data.json())
    .then((data) => {
        if (JSON.stringify(data) === '[]') {
            setPage(null)
            return
        }
        setPage(data[0])
    })
}

export { loadPosts, loadMedia, loadPost, checkIfPageExists, loadSponsors, loadPage, loadProjects, loadAlerts };
